import { Mtds } from '../index'
import { ArrowSquareOutIcon, LockKeyIcon } from 'prove-common'

type AccessDeniedScreenProps = {
  title?: string
  description?: string
  requestAccessMessage?: string
  accessInformationMessage?: string
  showAccessInformation?: boolean
}

const accessInformationUrl =
  'https://mattilsynet.sharepoint.com/sites/Hovedkontoret/SitePages/team-pr%C3%B8vetaking.aspx?web=1&e=wSr6DTOCPE-VkM39dUDdOQ&at=15'

export const AccessDeniedScreen = ({
  title = 'Ingen tilgang',
  description = 'Kontakt din leder eller brukerstøtte dersom du trenger tilgang.',
  requestAccessMessage,
  accessInformationMessage = 'Les mer om tilganger til Prøveta og Prøveplan på teamsiden vår.',
  showAccessInformation = true
}: AccessDeniedScreenProps) => {
  return (
    <Mtds.Flex
      data-align='center'
      data-center='md'
      data-items='full'
      className='min-h-screen'
    >
      <Mtds.Card data-pad='7-12' data-radius='xl' className='text-center'>
        <Mtds.Grid data-gap='6' data-justify='center'>
          <LockKeyIcon size={48} aria-hidden='true' />

          <Mtds.Heading as='h1' data-size='md' data-justify='center'>
            {title}
          </Mtds.Heading>

          {description && <Mtds.Ingress>{description}</Mtds.Ingress>}

          {requestAccessMessage && (
            <Mtds.Muted>{requestAccessMessage}</Mtds.Muted>
          )}

          {showAccessInformation && (
            <Mtds.Link
              href={accessInformationUrl}
              target='_blank'
              rel='noopener noreferrer'
            >
              {accessInformationMessage}
              <ArrowSquareOutIcon aria-hidden='true' />
            </Mtds.Link>
          )}
        </Mtds.Grid>
      </Mtds.Card>
    </Mtds.Flex>
  )
}
